const ENDPOINT = 'https://events.cybertrends.co/support-ticket'
const DONE_MSG = 'Thank you for your message. We will get back to you as soon as possible.'

export default function (app) {
  document.getElementById('submit').disabled = false

  document.querySelector('form').addEventListener('submit', (evt) => {
    evt.preventDefault()

    const url = new URL(window.location)

    const body = {
      client: {
        app,
        version: url.searchParams.get('v'),
        platform: url.searchParams.get('platform'),
      },
      name: evt.target.querySelector('input[name="name"').value,
      email: evt.target.querySelector('input[name="email"').value,
      body: evt.target.querySelector('textarea[name="body"').value,
      test: url.searchParams.get('test') === '1'
    }

    fetch(ENDPOINT, {method: 'post', body: JSON.stringify(body)}).then(() => {
      const main = document.querySelector('main')
      const p = document.createElement('p')
      p.innerText = DONE_MSG
      main.innerHTML = ''
      main.appendChild(p)
    })
  })
}
